import React from 'react';
import { Card } from 'components/cards/Card';
import { Text } from 'components/typography';
import { PlusIcon } from 'assets/icons/PlusIcon';
import { ProcessingLoader } from 'components/loaders/ProcessingLoader';
import { ShouldRender } from 'components/ShouldRender';
import styles from './styles.module.scss';

export const ScheduleCard = ({ date, from, to, address, onClick, isLoading, dateTo, showRange = false }) => (
  <Card
    transparent
    className={styles.card}
  >
    <ShouldRender condition={!showRange}>
      <div className={styles.textWrapper}>
        <div>
          <Text
            bold
            size={18}
          >
            {date}
          </Text>

          <Text size={15}>{address}</Text>
        </div>

        <Text
          size={18}
          bold
        >
          {from} - {to}
        </Text>
      </div>
    </ShouldRender>

    <ShouldRender condition={showRange}>
      <div className={styles.textWrapper}>

        <div>
          <Text
            bold
            size={18}
          >
            {date} {from} - {dateTo} {to}
          </Text>
      
          <Text size={15}>{address}</Text>
        </div>
      </div>

    </ShouldRender>

    <div className={styles.actionSection}>
      {isLoading ? <ProcessingLoader />
        : (
          <div className={styles.addIcon}>
            <PlusIcon
              fill="#ffffff"
              onClick={onClick}
            />
          </div>
        )}
    </div>
  </Card>
);
